export default "__VITE_ASSET__3a80e7ed__"